import { StandardLayout } from './StandardLayout';
import { PillarLayout } from './PillarLayout';
import { GuideLayout } from './GuideLayout';
import { ReviewLayout } from './ReviewLayout';

/**
 * ArticleLayoutDispatcher
 * 
 * - 'pillar' -> PillarLayout (Ultimate Guides)
 * - 'guide'  -> GuideLayout (How-To / Comprehensive)
 * - 'review' -> ReviewLayout (Product Reviews)
 * - 'article' -> StandardLayout (Default Blog Posts)
 */
export const ArticleLayoutDispatcher = ({ article }) => {
    if (!article) return null;

    // Dispatch based on layoutType (added by generateArticlesMetadata.js)
    switch (article.layoutType) {
        case 'pillar':
            return <PillarLayout article={article} />;

        case 'guide':
            return <GuideLayout article={article} />;

        case 'review':
            return <ReviewLayout article={article} />;

        case 'article':
        default:
            return <StandardLayout article={article} />;
    }
};
